import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: e = 16, useVw: n, useRem: l, color: i, withColor: o, removeClassName: t, disableSSR: m, style: c, ...p }) => {
  const h = c ? { ...d, ...c } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-lianghuajijin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-éååºé"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: o ? r(i, 0, "#262933") : "#262933",
        datafollowfill: o ? r(i, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M20.4 7.7a3.9 3.9 0 1 1 7.8 0 3.9 3.9 0 0 1-7.8 0Zm3.9-2.1a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M4.1 11A6.9 6.9 0 0 1 11 4.1h6.059a.9.9 0 0 1 0 1.8H11A5.1 5.1 0 0 0 5.9 11v11a4.1 4.1 0 0 0 4.1 4.1h12a4.1 4.1 0 0 0 4.1-4.1v-7.109a.9.9 0 1 1 1.8 0V22a5.9 5.9 0 0 1-5.9 5.9H10A5.9 5.9 0 0 1 4.1 22V11Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M22.37 15.551a.9.9 0 0 0-1.423-1.102l-2.756 3.555a.308.308 0 0 1-.424.049l-2.182-1.717-.007-.005a2.1 2.1 0 0 0-2.947.377L9.787 20.4a.9.9 0 0 0 1.426 1.098l2.843-3.69a.3.3 0 0 1 .42-.056l2.182 1.718.006.005a2.108 2.108 0 0 0 2.94-.357l.006-.007 2.76-3.56Z"
        }
      )
    )
  )));
}, j = f;
export {
  j as default
};
